export const IMAGE_MODAL_SELECTORS = {
   GALLERY_TAB: '#gallery',
   GENERAL_TAB: 'button[data-bs-target="#general"]',
   URL_INPUT: '#imageUrlInput',
   WIDTH_INPUT: '#imageWidthInput',
   HEIGHT_INPUT: '#imageHeightInput',
   ALT_TEXT_INPUT: '#imageAltTextInput',
} as const;